import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DialogComponent } from 'src/app/components/dialog/dialog.component';
import { GroupService } from '../group.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Group } from 'src/app/shared/interfaces/group.interface';

@Component({
  selector: 'app-group-list',
  templateUrl: './group-list.component.html',
  styleUrls: ['./group-list.component.css'],
})
export class GroupListComponent implements AfterViewInit {
  constructor(
    private groupService: GroupService,
    private router: Router,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private toatsr: ToastrService
  ) {
    this.getGroups();
  }

  displayedColumns: string[] = ['id', 'name', 'actions'];
  dataSource = new MatTableDataSource<Group>();
  searchValue = '';
  groups: Group[] = [];
  @ViewChild(MatPaginator) paginator: MatPaginator;

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit() {}

  delete(id: number, name: string): void {
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '400px',
      height: '250px',
      data: {
        title: 'Excluir',
        text: ' Deseja remover a célula ? ',
        name: name,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.groupService
          .deleteUser(id)
          .then((res: any) => {
            this.snackBar.open(res.message, null, {
              duration: 4000,
            });
            this.dataSource = new MatTableDataSource<Group>();
            this.getGroups();
          })
          .catch((err: any) => {
            this.snackBar.open(err.error.message || 'Algo de errado aconteçeu');
          });
      }
    });
  }

  getGroups(): Promise<any> {
    return this.groupService
      .get()
      .then((res) => {
        this.groups = res;
        if (res.length == 0) {
          this.toatsr.error('Nenhuma Célula encontrada!');
        }
      })
      .catch((err) => {
        this.toatsr.error(err.error.message);
      });
  }

  openEdit(id: number): void {
    this.router.navigateByUrl('celula/' + id);
  }

  search(searchValue: string) {
    return this.groupService
      .search(searchValue)
      .then((res) => {
        this.groups = res;
      })
      .catch((err) => {
        this.toatsr.error(err.error.message || 'Falha na busca');
      });
  }
}
